// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { convertDateToDateOnlyString } from "@insite/client-framework/Common/Utilities/DateUtilities";
import getCurrentDateMinuteZero from "@store/Framework/Common/Utilities/getCurrentDateMinuteZero";
import EventListState from "@store/Framework/Store/Store/Pages/EventList/EventListState";
import { GetEventsApiParameter } from "@store/Framework/Store/Store/Pages/EventList/Handlers/GetEventList";
import { Draft } from "immer";

const initialDate = convertDateToDateOnlyString(getCurrentDateMinuteZero());

const initialState: EventListState = {
    getEventPagesParameters: {
        startDate: initialDate,
    },
};

const actions = {
    "Store/Pages/EventList/UpdateLoadParameter": (
        draft: Draft<EventListState>,
        { parameter }: { parameter: GetEventsApiParameter },
    ) => {
        draft.getEventPagesParameters = parameter;
    },
    "Store/Pages/EventList/ClearParameter": (draft: Draft<EventListState>) => {
        draft.getEventPagesParameters = { startDate: initialDate };
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreEventListActions = Parameters<typeof reducer>[1];
export default reducer;
